module.exports = __webpack_public_path__ + "static/media/payments-illustration--cropped@1x.a2d93d60.png";